"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsEpciMapContextInfo", function () {
    return {
        restrict: "E",
        require: "^obsEpciManager",
        scope: true,
        replace: true,
        template: require("./obsEpciMapContextInfo.html"),
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/epci/obsEpciMapContextInfo.js